import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

function startSwiper(element, properties) {
    if (properties) {
        const { 
            blockId = '', 
            slide_show = 1, 
            spaceBetween = 0,
            direction = 'horizontal', 
            dots = false, 
            arrows = false, 
            auto_play = false, 
            infinite = false,
            speed = 300, 
            effects = 'slide', 
            delaySlide = 3000,
            slide_show_mobile = 1, 
            arrowsMobile = false,
            dotsMobile = false,
            infiniteMobile = false,
            autoPlayMobile = false
        } = properties;

        let AddDirection = 'horizontal';
        if (direction == true) { 
            AddDirection = 'vertical';
        }
        
        let addAutoPlay = false;
        if (auto_play == true) {
            addAutoPlay = { 
                delay: parseInt(delaySlide),
            };
        }

        let addNavigation = false;
        if (arrows == true) {
            addNavigation = {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            };
        } else {
            const allArrows = element.querySelectorAll('.swiper-button-next, .swiper-button-prev');
            allArrows.forEach(e => { e.style.display = 'none'; });
        }

        let addPagination = false;
        if (dots == true) {
            addPagination = {
                el: '.swiper-pagination',
                clickable: true,
            };
        }     

        /** Configuración para dispositivos móviles */
        let addAutoPlayMobile = false;
        if (autoPlayMobile == true) {
            addAutoPlayMobile = { 
                delay: parseInt(delaySlide),
            };
        }

        let addNavigationMobile = false;
        if (arrowsMobile == true) {
            addNavigationMobile = {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            };
        }

        let addPaginationMobile = false;
        if (dotsMobile == true) {
            addPaginationMobile = {
                el: '.swiper-pagination',
                clickable: true,
            };
        }

        const swiper = new Swiper(element, {
            pagination: addPaginationMobile,
            navigation: addNavigationMobile,
            loop: infiniteMobile,
            effect: effects,       
            autoplay: addAutoPlayMobile,
            direction: AddDirection,
            speed: parseInt(speed),
            slidesPerView: parseInt(slide_show_mobile),
            spaceBetween: parseInt(spaceBetween),
            allowSlideNext: true,
            allowSlidePrev: true,
            allowTouchMove: true, 
            autoHeight: true, 
            grabCursor: true,
            breakpoints: {
                780: {
                    pagination: addPagination,
                    navigation: addNavigation,
                    loop: infinite,   
                    autoplay: addAutoPlay,
                    allowTouchMove: true, 
                    slidesPerView: slide_show,
                }
            },
        });

        customBtnMove(element, swiper);
    } else {
        console.warn('Las propiedades de swiper son nulas.');
        return;
    }
}

const customBtnMove = (element, swiperStart) => {
    const getNextSlideBtn = element.querySelectorAll('.js-slide-to');

    if (getNextSlideBtn) { 
        getNextSlideBtn.forEach(e => {
            let getIdElement = parseInt(e.id);
            e.addEventListener('click', event => {    
                swiperStart.slideTo(getIdElement, 1000, true);
            });
        });
    }
}

window.addEventListener('load', (event) => {
    const getCointentSlider = document.querySelectorAll('.swiper');
    
    getCointentSlider.forEach(element => {
        const propertiesAttribute = element.getAttribute('data-set-slider');
        
        if (propertiesAttribute) {
            const properties = JSON.parse(propertiesAttribute);
            startSwiper(element, properties);
        } else {
            // console.warn('El elemento .swiper no tiene el atributo data-set-slider. por que no es un bloque sliderv2');
        }
    });
});

